<template>
  <div class="body">
    <!-- 本页面打印 -->
    <div class="batch-print" ref="toImage">
      <!-- <h1 style="text-align: center">报告打印</h1> -->
      <img :src="imgUrl" alt="" style="width: 100%" />
    </div>
    <el-card class="box_card" style="position: relative" v-loading="printLoading" element-loading-text="页面生成打印中..."
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="header flex flex-middle">
        <div class="header_title flex flex-middle" @click="retrunBack">
          <i class="iconfont icontuichu"></i>
          <span>返回列表</span>
        </div>
        <div>
          <el-button type="warning" plain icon="el-icon-printer" size="small" @click="toPrint">页面打印</el-button>
        </div>
      </div>
      <div class="middle_table">
        <div ref="printAll" style="padding: 22px 0 0 30px;box-sizing: border-box;">
          <div style="position: relative; width: 90%">
            <div class="patient flex flex-middle flex-middle bold">
              <div class="flex flex-middle patient-l">
                <span class="userName"> {{ reportDetail.patientName ? reportDetail.patientName : '' }} </span>
                <span class="age"> | {{ reportDetail.patientSex ? reportDetail.patientSex : '' }} | {{ reportDetail.patientAge ? reportDetail.patientAge : '' }}</span>
              </div>
              <!-- <div v-show="isPrint" class="flex-one flex flex-middle flex-wrap">
                <i v-if="isShowEye" class="iconfont iconzhengyan" style="cursor: pointer; font-size: 20px; color: #2d99d7"
                  @click="showEye(false)"></i>
                <i v-if="!isShowEye" class="iconfont iconbiyan1" style="cursor: pointer; font-size: 20px; color: #2d99d7"
                  @click="showEye(true)"></i>
                <div class="tagItem" v-for="(item, index) in tagList" :key="index">
                  <el-tag type="warning">{{ item.tag }}</el-tag>
                </div>
              </div> -->
            </div>
            <div class="patient_info flex flex-middle">
              <div class="patient_info_item">
                <i class="iconfont iconshenfenzheng" />
                <span>{{ reportDetail.cml_Customer_ID ? reportDetail.cml_Customer_ID : '' }}</span>
              </div>
              <div class="patient_info_item">
                <i class="iconfont icondianhua-1" />
                <span>{{ reportDetail.patientMobile ? reportDetail.patientMobile : ' 暂未填写' }}</span>
              </div>
              <div class="patient_info_item">
                <i class="iconfont iconshijian" />
                <span>创建时间：{{ reportDetail.createTime ? reportDetail.createTime : '' }}</span>
              </div>
            </div>
            <div class="patient_info flex flex-middle">
              <div class="patient_info_item">
                <i class="iconfont iconbarcode" />
                <span>条形码：{{ reportDetail.barcode ? reportDetail.barcode : ' 暂未填写' }}；</span>
              </div>
              <div class="patient_info_item">
                <i class="iconfont iconyisheng" />
                <span>开单医生：{{ reportDetail.doctorName ? reportDetail.doctorName : ' 暂未填写' }}</span>
              </div>
              <!-- <div class="patient_info_item" v-show="isShowEye">
                <i class="iconfont icondingdanjine" />
                <span>订单金额：￥{{ reportDetail.orsl_Order_summary_amount ? reportDetail.orsl_Order_summary_amount : '' }}</span>
              </div> -->
            </div>
            <div class="order_info bold flex flex-middle">
              <span class="order_info_num">订单编号：{{ reportDetail.documentNo ? reportDetail.documentNo : '' }}</span>
              <span class="info_tag info_tag_y"> 报告已出</span>
            </div>
            <div class="pdf_box" v-show="isPrint">
              <div class="pdf_left"  @click="clickJyPdF(reportDetail.reportAddress)">
                <div class="left_top">
                  <img src="../../../assets/img/pdf/jypdf.png" alt="" style="width: 50px; height: 50px; cursor: pointer" />
                </div>
                <div class="left_bottom">查看检验报告</div>
              </div>
              <!-- <div
                class="pdf_left"
                v-if="reportDetail.orsl_Interpretation_report_address"
                @click="clickTjPdF(reportDetail.orsl_Interpretation_report_address)"
              >
                <div class="left_top">
                  <img src="../../../assets/img/pdf/tjpdf.png" alt="" style="width: 50px; height: 50px; cursor: pointer" />
                </div>
                <div class="left_bottom right_bottom">查看体检报告</div>
              </div> -->
            </div>
          </div>
          <div class="report">
            <!-- 检测项目分解 -->
            <div class="report_info" v-for="(val, k1) in reportDetail.reportDetailList" :key="k1">
              <div class="report_title bold flex flex-middle flex-center">{{ val.pslName }}</div>
              <el-table :data="val.reportDetailList" :row-style="rowStyle">
                <el-table-column type="index" label="" width="55" align="center"></el-table-column>
                <el-table-column prop="pdlName" label="项目"> </el-table-column>
                <el-table-column prop="result" label="结果">
                  <template slot-scope="{ row }">
                    <span>{{ row.result }}</span>&nbsp;
                    <i v-if="row.resultFlag && row.resultFlag == 'H'"
                      style="color: #ff0000; font-size: 16px; font-weight: bold" class="el-icon-top"></i>
                    <i v-if="row.resultFlag && row.resultFlag == 'L'"
                      style="color: #00bb84; font-size: 16px; font-weight: bold" class="el-icon-bottom"></i>
                  </template>
                </el-table-column>
                <el-table-column prop="reference" label="参考范围" width="300">
                  <template slot-scope="scope">
                    <span style="color: #f04562; font-weight: bold">{{ scope.row.reference }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <p style="width: 100%; padding: 10px 0; box-sizing: border-box">
                <span style="color: orange; font-weight: bold; font-size: 14px; margin-left: 20px">项目小结:</span>
                <span style="font-size: 14px; color: #666666">
                  {{ val.orbps_Interpretation_of_doctors ? val.orbps_Interpretation_of_doctors : '暂无小结' }}
                </span>
              </p> -->
            </div>
            <!-- 报告解读 -->
            <div class="report_info" v-if="reportDetail.abnormalReportDetailList &&   reportDetail.abnormalReportDetailList.length > 0">
              <div class="report_title bold flex flex-middle flex-center">报告解读</div>
              <el-table :data="reportDetail.abnormalReportDetailList" >
                <el-table-column prop="pdlName" label="名称"  width="350"> </el-table-column>
                <el-table-column prop="result" label="结果"  width="200"> 
                  <template slot-scope="{ row }">
                    <span>{{ row.result }}</span>&nbsp;
                    <i v-if="row.resultFlag && row.resultFlag == 'H'" style="color: #ff0000; font-size: 16px; font-weight: bold" class="el-icon-top"></i>
                    <i v-if="row.resultFlag && row.resultFlag == 'L'" style="color: #00bb84; font-size: 16px; font-weight: bold" class="el-icon-bottom"></i>
                  </template>
                </el-table-column>
                <el-table-column prop="reference" label="参考范围" width="200"> </el-table-column>
                <el-table-column prop="" label="解读建议">
                  <template slot-scope="scope">
                    <span style="color: #2d99d7; font-weight: bold">{{ scope.row.interpret?scope.row.interpret:"" }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 备注 -->
            <div class="report_remark" @click="goPrint">提示： 本检测结果仅对来样负责，供临床参考。如对检测结果有疑问请在样本保存期内提出</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  name: 'ReportDetail',
  data() {
    return {
      printLoading: false, //打印加载提示
      isPrint: true, //打印是否显示
      imgUrl: '',
      isShowEye: false, //金额显示与隐藏
      reportDetail: {},
      documentNo: "",//订单号
      orderDetailLibrary: [], //项目明细详情
      reportInterpretation: [], //报告解读
      activeNames: '',
      customerId: '',
      tagList: [{ tag: '高血压' }, { tag: '糖尿病' }, { tag: '亚健康' }]
    };
  },
  async created() {
    this.documentNo = this.$route.query.documentNo ? this.$route.query.documentNo : '';
    this.getReportDetailYj();
    // this.reportDetail = await JSON.parse(localStorage.getItem('reportDetail'));
    // if (JSON.parse(localStorage.getItem('reportDetail')).Order_detail_Library) {
    //   this.orderDetailLibrary = await JSON.parse(localStorage.getItem('reportDetail')).Order_detail_Library;
    //   this.handleFun();
    // }
  },
  mounted() { },
  methods: {
    goPrint(){
      const that = this
      that.$print(that.$refs.toImage);
    },
    // 获取列表--改版
    getReportDetailYj() {
      const that = this;
      let params = {
        documentNo: that.documentNo
      };
      let personType = {
        category: 'WuFan'
      };
      request
        .post('/reportDetail', params, personType)
        .then((res) => {
          if (res.success) {
            that.reportDetail = res.data;
          } else {
            that.$message.error('抱歉，查询报告出错2');
          }
        })
        .catch((err) => {
          that.laodTable = false;
          that.$message.error('抱歉，查询报告出错1');
        });
    },
    // 生成页面截图塞到div上
    toPrint() {
      const that = this;
      that.printLoading = true;
      that.isPrint = false;
      that.$nextTick(() => {
        const rect = that.$refs.printAll.getBoundingClientRect(); // 关键代码
        that
          .$html2canvas(that.$refs.printAll, {
            scrollY: rect.top, // 关键代码
            height: rect.height + 50, // 加高度，避免截取不全
            width: rect.width - 80 // 减宽度，有padding
          })
          .then((canvas) => {
            canvas.toBlob((blob) => {
              that.isPrint = true;
              that.imgUrl = URL.createObjectURL(blob);
              
              // const aImg = document.createElement('a');
              // aImg.href = this.imgUrl;
              // // 使用该行，点击生成的图片没有.png后缀
              // // aImg.download = this.imgUrl
              // // 修改后点击生成的图片有.png后缀，可以预览
              // aImg.download = Date.now() + '.png';
              // document.body.appendChild(aImg);
              // aImg.click();
              // document.body.removeChild(aImg);
              setTimeout(() => {
                that.printLoading = false;
                that.$print(that.$refs.toImage);
              }, 2000);


            }, 'image/png');
          });
      });
    },
    // 小眼睛显示隐藏
    showEye(val) {
      this.isShowEye = val;
    },
    // 点击pdf报告
    clickTjPdF(path) {
      if (path) {
        window.open(path, '_blank');
      } else {
        that.$message.error('抱歉，未检测到体检报告地址，请重新核实体检报告状态；');
      }
    },
    // 点击pdf报告
    clickJyPdF(path) {
      if (path) {
        window.open(path, '_blank');
      } else {
        that.$message.error('抱歉，未检测到检验报告地址，请重新核实检验报告状态；');
      }
    },
    //报告解读处理函数（多层遍历）
    handleFun() {
      const that = this;
      that.reportInterpretation = [];
      that.orderDetailLibrary.map((item) => {
        item.order_breakdown_product_summary[0].order_breakdown_product_details.map((val) => {
          if (val.orbps_Interpretation_of_doctors) {
            that.reportInterpretation.push({
              orbps_Interpretation_of_doctors: val.orbps_Interpretation_of_doctors,
              pdl_name: val.pdl_name,
              papdl_Return_value: val.papdl_Return_value,
              orbpd_Result_marker: val.orbpd_Result_marker
            });
          }
        });
      });
    },
    retrunBack() {
      const that = this;
      const sorucePath = that.$route.query.sorucePath;
      if (sorucePath === 'queryIndex') {
        // 报告列表来的
        that.$router.push({ path: '/query', query: { name: '22222' } });
      } else if (sorucePath === 'patientFiles') {
        //患者列表来的
        that.$router.push({ path: '/patientFiles', query: { customerId: that.customerId } });
      }
    },
    // 行的样式
    rowStyle({ row }) {
      if (row.orbpd_Result_marker && row.orbpd_Result_marker == 'H') {
        //高标记红色
        const markH = {
          color: '#FF0000'
        };
        return markH;
        // return 'color: #FF0000; height: 40px';
      } else if (row.orbpd_Result_marker && row.orbpd_Result_marker == 'L') {
        //低标记绿色
        const markL = {
          color: '#00BB84'
        };
        return markL;
        // return 'color: #00BB84; height: 40px';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  box-sizing: border-box;
  height: calc(100vh - 90px);
  box-sizing: border-box;
  position: relative;

  .batch-print {
    position: absolute;
    top: 0;
    // left: 20000px;
    left: 5000px;
  }

  .iconpdf {
    color: #2d99d7;
    font-size: 30px;
    float: right;
    cursor: pointer;
  }

  .iconpdf:hover {
    color: #36b6ff;
    font-size: 30px;
    float: right;
  }

  // 去除卡片的padding
  ::v-deep .el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0px !important;
    border-radius: 30px 30px 0px 0px !important;
  }

  ::v-deep .el-card {
    border-radius: 30px 30px 0px 0px !important;
  }

  .box_card {
    height: 100%;
    margin-right: 30px;
    box-sizing: border-box;

    .header {
      padding: 15px 35px 15px 31px;
      background: #f0feff;
      border-radius: 30px 30px 0px 0px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      .header_title {
        color: #2d99d7;
        cursor: pointer;
        user-select: none;

        i {
          font-size: 26px;
          display: inline-block;
          margin-right: 11px;
        }

        span {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  }

  .middle_table {
    box-sizing: border-box;
    height: calc(100% - 60px);
    overflow-y: auto;

    .pdf_box {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 300px;
      height: 90px;
      // border: 1px solid red;
      display: flex;
      justify-content: flex-end;

      .pdf_left {
        width: 45%;
        // border: 1px solid red;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: flex-end;
        margin-left: 15px;

        .left_top {
          flex: 1;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .left_bottom {
          cursor: pointer;
          width: 110px;
          height: 26px;
          line-height: 26px;
          background: #daeffd;
          border: 1px solid #4f97d2;
          border-radius: 15px;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: center;
          color: #4f97d2;
          margin: 0 auto;
        }

        .right_bottom {
          color: #32bfc5;
          background: #f0feff;
          border: 1px solid #32bfc5;
        }
      }
    }

    .patient {
      color: #333333;

      .patient-l {
        margin-right: 14px;

        .userName {
          font-size: 24px;
        }

        .age {
          font-size: 18px;
        }
      }

      .tagItem {
        margin-right: 10px;
      }
    }

    .patient_info {
      margin-top: 10px;

      .patient_info_item {
        margin-right: 50px;
        color: #666666;
        font-size: 16px;
        font-weight: 400;

        i {
          color: #2d99d7;
          display: inline-block;
          margin-right: 9px;
          font-size: 18px;
        }
      }
    }

    .order_info {
      font-size: 16px;
      margin-top: 15px;
      color: #333333;

      .order_info_num {
        margin-right: 22px;
      }

      .info_tag {
        margin-right: 40px;
        display: inline-block;
        width: 84px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        border-radius: 15px;
      }

      .info_tag_y {
        background: #dcffe7;
        color: #23bd54;
      }

      .info_tag_part {
        background-color: #fff6ea;
        color: #d89330;
      }

      .info_tag_no {
        background-color: #ebebeb;
        color: #999999;
      }

      .info_tag_pass {
        background-color: #eafeff;
        color: #31bfc5;
      }
    }

    .report {
      width: 90%;
      margin: 18px 0;
      height: auto;
      box-sizing: border-box;

      // 设置表格左边距
      ::v-deep .el-table .cell {
        padding-left: 30px !important;
      }

      .report_info {
        height: auto;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        background: #fff;
        border-radius: 16px;
        margin-bottom: 20px;

        .report_body {
          height: auto;
          padding: 0 0 10px 0;
          box-sizing: border-box;

          .title_contentactive {
            width: 100%;
            height: 45px;
            padding-left: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #2d99d7;
            background: #d5f0ff;
            border-radius: 5px;
            padding: 0 20px;
            box-sizing: border-box;
          }

          .tittle_body {
            width: 100%;
            box-sizing: border-box;

            .title_item {
              height: 30px;
              font-size: 13px;
              color: #666666;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid #f3eeee;
              padding: 0 20px;
              box-sizing: border-box;
            }

            .title_item:hover {
              background: #f5f7fa;
            }
          }
        }

        .report_title {
          background: #31bfc5;
          border-radius: 16px 16px 0px 0px;
          padding: 21px 10px;
          box-sizing: border-box;
          font-size: 24px;
          color: #f8f9fe;
        }

        .topIcon {
          color: #f04562;
          font-size: 14px;
          font-weight: bold;
          margin-left: 5px;
        }

        .bottomIcon {
          color: #2d99d7;
          font-size: 14px;
          font-weight: bold;
          margin-left: 5px;
        }

        .report_remark {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
}</style>
